<template>
  <div
    :class="[
      'text-center',
      containerClass
    ]"
  >
    <!-- Circular Spinner -->
    <div
      v-if="style === 'circle'"
      :class="[
        'inline-block animate-spin rounded-full border-b-2',
        sizeClass,
        colorClass
      ]"
    />
    
    <!-- Arrow Path Icon Spinner -->
    <ArrowPathIcon
      v-else-if="style === 'arrow'"
      :class="[
        'animate-spin',
        sizeClass,
        iconColorClass
      ]"
    />
    
    <p
      v-if="showText"
      :class="[
        'mt-2',
        textClass
      ]"
    >
      <slot>{{ text }}</slot>
    </p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { ArrowPathIcon } from '@heroicons/vue/24/outline'

interface Props {
  size?: 'sm' | 'md' | 'lg' | 'xl'
  color?: 'primary' | 'secondary' | 'success' | 'warning' | 'error' | 'slate'
  style?: 'circle' | 'arrow'
  text?: string
  showText?: boolean
  containerClass?: string
  textClass?: string
}

const props = withDefaults(defineProps<Props>(), {
  size: 'md',
  color: 'primary',
  style: 'circle',
  text: 'Cargando...',
  showText: true,
  containerClass: 'py-8',
  textClass: 'text-gray-600 dark:text-gray-400'
})

const sizeClass = computed(() => {
  const sizes = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
    xl: 'h-16 w-16'
  }
  return sizes[props.size]
})

const colorClass = computed(() => {
  const colors = {
    primary: 'border-indigo-600',
    secondary: 'border-slate-600',
    success: 'border-emerald-600',
    warning: 'border-amber-600',
    error: 'border-red-600',
    slate: 'border-slate-400'
  }
  return colors[props.color]
})

const iconColorClass = computed(() => {
  const colors = {
    primary: 'text-indigo-600',
    secondary: 'text-slate-600',
    success: 'text-emerald-600',
    warning: 'text-amber-600',
    error: 'text-red-600',
    slate: 'text-slate-400'
  }
  return colors[props.color]
})
</script>
